import { observer } from 'mobx-react-lite';
import React from 'react';
import { countryToFlag } from '../location';
import { ShippingCountryState } from '../shipping';

let CurrencyInformation = ({
  htmlProps = {},
}: {
  htmlProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
}) => {
  const { className = '', ...rest } = htmlProps;
  const flagElement = <span>{countryToFlag(ShippingCountryState?.countryCode?.toLowerCase() || '')}</span>;

  return (
    <div {...rest} className={`CurrencyInformation ${className}`}>
      <h6 className="title h6">Currency</h6>
      <div className="currency-info">
        <div className="GlobalLinkNoTx flag">{flagElement}</div>
        <div>{ShippingCountryState?.country?.currencyName}</div>
        <span className="alo-checkmark-in-circle-icon"></span>
      </div>
    </div>
  );
};
CurrencyInformation = observer(CurrencyInformation);
export { CurrencyInformation };
